module.exports = __webpack_public_path__ + "img/icon-folder.52d5225d.svg";